if (!customElements.get('copied-option-picker')) {
  customElements.define(
    'copied-option-picker',
    class CopiedOptionPicker extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.addEventListener('change', this.handleChange.bind(this));
      }

      handleChange(event) {
        const input = event.target.closest('[data-copied-option-input]');
        if (!input || input.tagName !== 'INPUT') return;

        const selectedValue = this.querySelector('[data-copied-option-selected-value]');
        if (selectedValue) {
          selectedValue.textContent = input.dataset.optionDisplayValue || input.value;
        }
      }
    }
  );
}
